import TipoRefService from "@/services/TipoRefService";

import { bool } from "yup";
//this.$store.state.user.users,current_page
export const tipoRef = {
    namespace:true,
    state: {tipoRef:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListTiporef({commit},pageNumber){
            return await TipoRefService.getlist(pageNumber).then(
                response=>{    
                    commit('setTiporef',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListTiporef({commit},search){          
            return await TipoRefService.getSearch(search).then (
                response =>{                    
                    commit('setTiporef',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setTiporef(state,data){
        state.tipoRef = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.tipoRef.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};